module.exports = __webpack_public_path__ + "img/small.883b7c6b.jpg";